var React = require('react');

function Divide (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M224 160a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm0 192a64 64 0 1 0 64 64 64 64 0 0 0-64-64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 240a32 32 0 0 1 32-32h384a32 32 0 0 1 32 32v32a32 32 0 0 1-32 32H32a32 32 0 0 1-32-32z","className":"fa-primary","key":2})]);
}

Divide.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Divide;

Divide.default = Divide;
